import { AppointmentCalender } from "./appointmentCalendar.component";
import { DashboardFilter } from "./dashboardFilter.component";
import { DashboardSidebar } from "./dashboardSidebar.component";
import { ApiSchemaAppointmentByMonth } from "../../models/api/appointment";
import filterPanel from "../../assets/img/filter-panel-icon.svg";
import upSolidIcon from "../../assets/img/header-chevron-up-solid.svg";
import downSolidIcon from "../../assets/img/header-chevron-down-solid.svg";
import { ExportButton } from "../../components/export.component";

export const DashboardAppointment = ({
  data,
  isValidating,
}: {
  data: ApiSchemaAppointmentByMonth[] | undefined;
  isValidating?: boolean;
}) => {
  return (
    <div className="row gx-0 g-lg-2 g-md-2">
      <div className="col-xxl-9 col-xl-8 col-lg-8 col-md-6 col-sm-12 col-12 mb-lg-0 mb-2 mt-0">
        <div className="content-box bg-white">
          <div className="content-box-header">
            <div className="row align-items-center  justify-content-between">
              <div className="col content-box-title">
                <div>
                  <p className="text-capitalize mb-0">All Appointments</p>
                </div>
                <div className="collapse-icon"></div>
              </div>
              <div className="col">
                <form action="" className="search-component">
                  <div className="input-group me-3"></div>
                  <a
                    className="btn search-filter-btn me-3"
                    data-bs-toggle="collapse"
                    href="#filterPanel"
                    role="button"
                    aria-expanded="false"
                    aria-controls="filterPanel"
                  >
                    <img
                      src={filterPanel}
                      alt="filter-panel-icon"
                      className="img-fluid svg-btn"
                    />
                  </a>
                  <ExportButton params={{}} component="Appointment" />
                  <a
                    className="btn  box-collapse-btn me-1"
                    data-bs-toggle="collapse"
                    href="#dashboard-collapsable-AllAppointment"
                    role="button"
                    aria-expanded="false"
                    aria-controls="dashboard-collapsable-AllAppointment"
                  >
                    <img
                      src={upSolidIcon}
                      alt="up"
                      className="img-fluid svg-btn collapse-close"
                    />
                    <img
                      src={downSolidIcon}
                      alt="down"
                      className="img-fluid svg-btn collapse-open"
                    />
                  </a>
                </form>
              </div>
            </div>
          </div>
          <div
            className="collapse show clearfix position-relative"
            id="dashboard-collapsable-AllAppointment"
          >
            <div className="border-top"></div>
            <div
              className="collapse mt-3 mb-4 p-4 border-bottom border-1"
              id="filterPanel"
            >
              <DashboardFilter />
            </div>
            <div className="content-box-body pt-0">
              {!data?.length && (
                <div className="my-2 mx-auto text-center text-muted">
                  No Appointments Available
                </div>
              )}

              <div className="row ">
                <div className="col-12 mt-3">
                  <div className="dashboard-calender">
                    <AppointmentCalender
                      data={data}
                      isValidating={isValidating}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mb-lg-0 mb-2 mt-0">
        <div className="content-box bg-white h-100">
          <div className="content-box-header">
            <div className="row align-items-center  justify-content-between">
              <div className="col content-box-title">
                <div>
                  <p className="text-capitalize mb-0">Schedule Details</p>
                </div>
                <div className="collapse-icon"></div>
              </div>

              <a
                className="btn  box-collapse-btn me-1"
                data-bs-toggle="collapse"
                href="#dashboard-collapsable-scheduleDetails"
                role="button"
                aria-expanded="false"
                aria-controls="dashboard-collapsable-scheduleDetails"
              >
                <img
                  src={upSolidIcon}
                  alt="up"
                  className="img-fluid svg-btn collapse-close"
                />
                <img
                  src={downSolidIcon}
                  alt="down"
                  className="img-fluid svg-btn collapse-open"
                />
              </a>
            </div>
          </div>
          <div
            className="collapse show clearfix position-relative"
            id="dashboard-collapsable-scheduleDetails"
          >
            <div className="border-top"></div>
            <div className="content-box-body schedule-details-container dashboard-sidebar">
              <DashboardSidebar />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
